/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum CanvasTokenType {
  OP = 0,
  VOID = 1,
  VARINT = 2,
  VARSINT = 3,
  COLOR = 4,
  INT = 5,
  FIXEDFLOAT = 6,
  VARFLOAT = 7,
  RECT = 8,
  POINT = 9,
  POINTF = 10,
  MATRIX = 11,
  MATRIX6 = 12,
  ULONG = 13,
}
